import { FC, useMemo, useState } from 'react';
import { GraphQLProvider } from '../../shared/context/GraphQLProvider';
import { ProductSpecification, type ProductProperty } from './ProductSpecification';
import { ProductPageEtimTranslationLoader } from '../../shared/translations/EtimTranslationsLoader';

type ProductSpecificationListProps = {
  specifications: ProductProperty[];
};

export const ProductSpecificationList: FC<ProductSpecificationListProps> = ({ specifications }) => {
  const [showAll, setShowAll] = useState(false);

  const ids = useMemo(() => specifications.map((v) => v.FeatureID), [specifications]);

  return (
    <GraphQLProvider>
      <ProductPageEtimTranslationLoader ids={ids} />
      <div className="product-specifications">
        {specifications.slice(0, showAll ? undefined : 20).map((property) => (
          <div key={property.FeatureID} className="product-specifications__row is-grid has-col-5-lg">
            <ProductSpecification property={property} />
          </div>
        ))}
      </div>
      {!showAll && specifications.length > 20 && (
        <div className="product-content__list__show-all_button">
          <button onClick={() => setShowAll(true)}>{theme.locales.showAll}</button>
        </div>
      )}
    </GraphQLProvider>
  );
};
